import type { CommodityDetail } from '../../../mocks/commodities';

interface Props {
  commodity: CommodityDetail;
}

export default function CommodityOverview({ commodity }: Props) {
  return (
    <section className="bg-white py-20 px-6 lg:px-16">
      <div className="max-w-5xl mx-auto">
        {/* Text */}
        <div className="text-center mb-14">
          <p className="text-[#d4571a] text-xs font-bold tracking-widest uppercase mb-4">
            Overview
          </p>
          <h2 className="text-[#071525] text-3xl md:text-4xl font-bold leading-tight mb-6">
            {commodity.overviewTitle}
          </h2>
          <p className="text-[#071525]/60 text-base leading-relaxed max-w-3xl mx-auto">
            {commodity.overviewText}
          </p>
        </div>


      </div>
    </section>
  );
}
